import { ReactNode } from 'react';

import { cx } from '@libs/classnames';

import { CAMERA_HINTS } from '@features/video/constants';

import { Props as StreamCameraProps, StreamCamera } from './StreamCamera';

import styles from './StreamPanel.module.css';

export type Props = {
  className?: string;
  // сообщение судьи, например требование второй камеры
  notice?: ReactNode;
  // одна камера или две, если требуют судьи; две встают рядом, если хватает ширины
  cameras: StreamCameraProps[];
};

// Содержимое модалки видеоконтроля: уведомление и колонки камер
export function StreamPanel({ className, notice, cameras }: Props) {
  const isMultiple = cameras.length > 1;

  return (
    <div className={cx(styles.panel, className)}>
      {notice && <p className={styles.panel__notice}>{notice}</p>}

      <div className={styles.panel__cameras}>
        {cameras.map((camera, i) => (
          <StreamCamera
            key={i}
            {...camera}
            className={cx(styles.panel__camera, { [styles.is_multiple]: isMultiple })}
            title={camera.title ?? (isMultiple ? `Камера ${i + 1}` : undefined)}
            hint={camera.hint ?? CAMERA_HINTS[i]}
          />
        ))}
      </div>
    </div>
  );
}
